export function formatContent(content) {
    // Split the content into an array of strings and image grid markers
    let splitContent = content.split(/(<div class="image-grid.*?>.*?<\/div>|<div class="promo-rewards">.*?<\/div>)/gs);

    // Replace image grid markers with ImageGrid components and promo rewards markers with PromoRewardsTable components
    splitContent = splitContent.map(part => {
        if (part.startsWith('<div class="image-grid')) {
            return { type: 'ImageGrid', content: part };
        } else if (part.startsWith('<div class="promo-rewards">')) {
            return {
                type: 'PromoRewardsTable',
                month: part.match(/month="(\d+)"/)[1],
                year: part.match(/year="(\d+)"/)[1],
                rewardType: part.match(/type="([\w-]+)"/)[1],
            };
        } else {
            return { type: 'text', content: part };
        }
    });

    return splitContent;
}